<script setup>

const props = defineProps({
    tag: {
        type: Object,
        required: true
    },
    displayCounts: {
        type: Array,
        required: false,
        default: () => []
    }
})

</script>

<template>
    <div class="text-xxs flex space-x-2">
        <div
            v-if="displayCounts.includes('total')"
            class="min-w-6"
        >
            <i class="fa-regular fa-users mr-px opacity-50"></i>
            {{ tag.leads_count }}
        </div>
        <div
            v-if="displayCounts.includes('email')"
            class="min-w-6"
        >
            <i class="fa-regular fa-user mr-px opacity-50"></i>
            {{ tag.leads_with_email_count }}
        </div>
        <div
            v-if="displayCounts.includes('phone')"
            class="min-w-6"
        >
            <i class="fa-regular fa-phone mr-px opacity-50"></i>
            {{ tag.leads_with_phone_count }}
        </div>
    </div>
</template>

<style scoped>

</style>
